import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api';
import { NAVEGACION_ENDPOINTS } from '@/features/admin/api/endpoints';
import type { ModuloMenuDto } from '@/features/admin/types/menu.types';

export function useMenuQuery() {
  return useQuery({
    queryKey: ['navegacion', 'menu'],
    queryFn: () => apiClient<ModuloMenuDto[]>(NAVEGACION_ENDPOINTS.MENU),
    staleTime: 1000 * 60 * 10,
  });
}
